/**
* @description: 首页
* @author: fire
* @update: hwx
* @update: lyr(2022-01-14)
* @update: chy
*/
<template>
	<div class="index">
		<div class="index-content">
			<div class="innerContainer">
				<p class="clues">注：建议使用谷歌浏览器打开</p>
				<div class="user-info">
					<div class="user-head">
						<img src="../assets/images/user-head.png" />
					</div>
					<div class="user-position">
						<div class="detail-title">
							<div class="line"></div>
							<div class="text">{{ userName }}</div>
							<div class="line"></div>
						</div>
					</div>
					<div class="user-mobile">
						<i class="icon-telephone"></i>
						<span class="um-text">{{ mobile }}</span>
					</div>
					<div class="version-name">{{ version_name }}</div>
					<span class="greeting">您好，欢迎登录智慧商家桌面版~</span>
				</div>
				<div class="menu-shortcut">
					<div class="menu-list" v-if="isShowMenuList">
						<v-menu :content="'block'"></v-menu>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import menu from '@/components/menu.vue';
import * as types from '@/store/types';
export default {
	name: '',
	components: {
		"v-menu": menu
	},
	data() {
		return {}
	},
	computed: {
		userName() {
			return this.$store.state.username;
		},
		mobile() {
			return this.$store.state.usermobile;
		},
		versionurl() {
			return this.$store.state.versionurl;
		},
		version_name() {
			return this.$store.state.version_name;
		},
		isShowMenuList() {
			return this.$store.state.isShowMenuList;
		},
		// 社区模式
		business_model() {
			return this.$store.state.business_model
		},
	},
	created() {
		// 更新到最新登录账户
		if (window.location.host.indexOf('localhost') == -1) {
			if (this.versionurl != window.location.href) {
				window.location.href = this.versionurl
			}
			if (this.$route.params.code == '-100') {
				location.reload()
			}
		}
		// 清空选中的菜单
		this.$store.commit(types.INDEX)
		if (this.mobile) {
			this.getMenuList()
		}
	},
	mounted: function () { },
	methods: {
		// 获取菜单
		getMenuList() {
			const _this = this

			Vue.axios.post('User/api_getMenus', {
				"header": Vue.request_header,
				"request": {
					"version": Vue.version,
					"param": {}
				},
				"comment": ""
			})
				.then(res => {
					if (res.data.response.result_code == "true") {
						console.log("🚀 ~ file: index.vue ~ line 90 ~ getMenuList ~ MENUNEW", res.data.response.resault.menu)
						let menu = res.data.response.resault.menu
						if (this.business_model == '1') { // 非社区模式 设置-自主参数设置不显示（25-11-28）
							menu.forEach(item => {
								menu = menu.filter(item => item.id != '1379')
								if (item.id == '544') { // 自助营业报表
									item.submenu = item.submenu.filter(subitem => subitem.id != '1380')
								}
							})
						}
						_this.$store.commit(types.MENUNEW, JSON.stringify(menu))
						_this.$store.commit(types.PRIVINFO, res.data.response.resault.priv_info)
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.index {
	height: 100%;

	.index-content {
		box-sizing: border-box;
		overflow-y: scroll;
		height: 100%;
		background: #fff;

		.innerContainer {
			width: 1200px;
			margin: 50px auto 0;

			.clues {
				color: red;
				font-size: 16px;
				line-height: 60px;
			}

			.user-info {
				display: inline-block;
				width: 400px;
				height: 400px;
				border: 1px solid #009af0;
				border-radius: 5px;
				text-align: center;

				.user-head {
					margin-top: 30px;
				}

				.detail-title {
					display: flex;
					width: 270px;
					margin: 20px auto;

					.line {
						display: inline-block;
						width: 87px;
						border-top: 1px solid #009af0;
						margin-top: 15px;
					}

					.text {
						display: inline-block;
						padding: 0 10px;
						margin: 0 auto;
						line-height: 30px;
						font-size: 18px;
					}
				}

				.user-mobile {
					.um-text {
						font-size: 18px;
						color: #333;
					}
				}

				.version-name {
					margin-top: 30px;
					color: #009af0;
					font-size: 16px;
				}

				.greeting {
					display: inline-block;
					margin-top: 30px;
					color: #009af0;
					font-size: 18px;
				}
			}

			.menu-shortcut {
				display: inline-block;
				vertical-align: top;
				font-size: 12px;

				.menu-list {
					width: 700px;
					margin-left: 100px;

					ul {
						display: flex;
						justify-content: space-between;
						flex-flow: wrap;
					}

					.menu-item {
						margin-bottom: 50px;
						cursor: pointer;

						.sign {
							width: 180px;
							height: 140px;
							border-radius: 6px;
							background-color: #009af0;
						}

						.title {
							border: 2px solid #009af0;
							line-height: 40px;
							color: #009af0;
							font-size: 18px;
							text-align: center;
							border-radius: 6px;
						}
					}
				}
			}
		}
	}
}
</style>